import { createSlice } from "@reduxjs/toolkit";
import { ConsentState } from "./consent.types";
import {
    getConsentHandleThunk,
    generateConsentHandleThunk,
    submitConsentThunk,
    rejectConsentThunk,
    submitSelfConsentThunk,
} from "./consentThunk";

const initialState: ConsentState = {
    loading: false,
    submitted: false,
    rejected: false,
};

const consentSlice = createSlice({
    name: "consent",
    initialState,
    reducers: {
        resetConsent: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateConsentHandleThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(generateConsentHandleThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.consentHandle = action.payload;
            })
            .addCase(generateConsentHandleThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(getConsentHandleThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(getConsentHandleThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.consentHandle = action.payload.CONSENT_HANDLE;

                // Map API response to ConsentDetails
                state.consent = {
                    CONSENT_ID: action.payload.CONSENT_HANDLE, // Using Handle as ID if ID missing
                    PURPOSE: action.payload.PURPOSEDESC || "Unknown Purpose",
                    PURPOSEDESC: action.payload.PURPOSEDESC,
                    FI_TYPES: action.payload.FITYPES || [], // Map FITYPES -> FI_TYPES
                    FREQUENCY: action.payload.FREQUENCYVALUE + " " + action.payload.FREQUENCYUNIT,
                    DATA_RANGE_FROM: action.payload.FIDATAFROMDATE,
                    DATA_RANGE_TO: action.payload.FIDATATODATE,
                    CONSENT_HANDLE: action.payload.CONSENT_HANDLE,
                    FIUID: action.payload.FIUID,
                    FIUNAME: action.payload.FIUNAME,
                    // ... map other fields as needed
                };
            })
            .addCase(getConsentHandleThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            .addCase(submitConsentThunk.fulfilled, (state) => {
                state.submitted = true;
            })
            .addCase(rejectConsentThunk.fulfilled, (state) => {
                state.rejected = true;
            })
            .addCase(submitSelfConsentThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(submitSelfConsentThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.submitted = true;
                // Store the consent ID or whatever is returned, if needed
                if (action.payload && action.payload.ConsentId) {
                    state.consentHandle = action.payload.ConsentId;
                }
            })
            .addCase(submitSelfConsentThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { resetConsent } = consentSlice.actions;
export default consentSlice.reducer;
